export default {
    units_import_title: 'Import Units',
    units_import_button: 'Import',
    units_import_cancel: 'Cancel',
    units_comma: 'Comma (,)',
    units_semicolon: 'Semicolon (;)',
    units_selectDelimiter: 'Select',
    units_delimiter: 'Delimiter',
    units_error_delimiter: 'Delimiter is required',
    units_import_instructions: 'Important Note: The ID column is mandatory. This import feature is only intended for updating existing records, perform a table export without editing the ID column value to maintain record reference. Please add "km" or "mi" at the end of the odometer values to specify the unit of measurement; If no unit is specified the data will be stored in miles.',
    units_download_template: 'Download Template',
    units_template_unitColumn: 'Unit',
    units_template_vinColumn: 'VIN',
    units_template_yearColumn: 'Year',
    units_template_makeColumn: 'Make',
    units_template_modelColumn: 'Model',
    units_template_tagsColumn: 'Tags',
    units_template_driverColumn: 'Driver',
    units_template_defaultDriverColumn: 'Default Driver',
    units_template_engineHoursColumn: 'Engine Hours',
    units_template_odometerColumn: 'Odometer',
    units_template_inspection_device_typeColumn: 'Inspection Device Type',
    units_template_inspection_tag_idColumn: 'Inspection Tag ID',
    units_template_power_unit_numberColumn: 'Power Unit Number',
    units_template_maintenance_companyColumn: 'Maintenance Company',
    units_template_registration_countryColumn: 'Registration Country',
    units_template_registration_stateColumn: 'Registration State',
    units_template_registration_expiration_dateColumn: 'Registration Expiration Date',
    units_template_engine_serial_numberColumn: 'Engine Serial Number',
    units_template_license_plateColumn: 'License Plate',
    units_template_asset_typeColumn: 'Asset Type',
    units_template_asset_subtypeColumn: 'Asset Subtype',


    units_import_error_CU01: 'Empty CSV file: The file contains no data rows. Please add at least one row with unit information.',
    units_import_error_CU02: 'Error in CSV format: ID column is required for unit updates.',
    units_import_error_CU03: 'No valid data rows found: ID and Label columns cannot be empty in all rows.',
};